module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-navbar', {
    attrs: {
      "title": "绑定成功"
    }
  }), _vm._v(" "), _c('c-page', {
    staticClass: "bg-color gray"
  }, [_c('c-content', [_c('div', {
    staticClass: "text-center card-bind-result"
  }, [_c('div', {
    staticClass: "card-info-panel"
  }, [_c('div', {
    staticClass: "success-icon"
  }, [_c('i', {
    staticClass: "text-color orange s-icon-check-circle-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.cardName) + "已到账")]), _vm._v(" "), _c('div', {
    staticClass: "text-color gray"
  }, [_vm._v("管理好产品是经营的第一要务哟 ")]), _vm._v(" "), _c('c-button', {
    staticClass: "mt-20 add-new-goods",
    nativeOn: {
      "click": function($event) {
        _vm.addNewGoods($event)
      }
    }
  }, [_vm._v("添加商品\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-color dark-gray"
  }, [_vm._v("\n          需要帮助？ "), _c('br'), _vm._v("\n          搜索微信号："), _c('span', {
    staticClass: "text-color orange"
  }, [_vm._v("syhao518")]), _vm._v("，专属客服为您解答！\n        ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-311528f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/coupon/card-bind/result/index.vue
// module id = 1031
// module chunks = 2